import { useQuery } from 'react-query';
import { useContext } from 'react';
import { AuthContext } from '../../Context/AuthContext';  


const fetchVesselClassifications = async (token) => {
  const response = await fetch(`${process.env.REACT_APP_SERVER_URL}/data/readVesselClassifications`, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });

  if (!response.ok) {
    throw new Error('Failed to fetch vessel classifications');
  }

  return response.json();
};


const useFetchVesselClassifications = () => {
  const { token } = useContext(AuthContext); 

  return useQuery('vesselClassifications', () => fetchVesselClassifications(token));
};

export default useFetchVesselClassifications;
